import { SalesOrderContractTaskPhase } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 1610. 受注案件契約タスクフェーズ一覧
 * [GET] /sales_order_contract_task_phases
 */
const salesOrderContractTaskPhases = (): Promise<SalesOrderContractTaskPhase[]> => {
  return axios.get(`/api/sales_order_contract_task_phases`);
};

export const useSalesOrderContractTaskPhases = () => {
  return useQuery({
    queryKey: ['sales_order_contract_task_phases'],
    queryFn: salesOrderContractTaskPhases
  });
};